module.exports = __webpack_public_path__ + "img/home.605201e1.svg";